<template>
  <div class='survey'>
    <div v-if='loadFailed' class='error'>
      <button type='button' class='btn' @click='getData'>再読み込み</button>
    </div>
    <p v-if='questions.length'>
      {{ this.current + 1 }} 問目（全 {{ this.questions.length }} 問）:
    </p>

    <div class="progress-bar" v-if='questions.length'>
      <div class="progress-bar__indicator" :style='"width: "+progress'></div>
    </div>

    <div class="survey__question question" v-if='curQ'>
      <div class="question__content"
        v-text='(current < 10 ? current + 1 + ": ": "") + curQ.title + this.validationWord()'>
      </div>
      
      <div class="question__choices" v-if='curQ.question_type === "boolean"'>
        <button type='button'
          :class  ='curQ.answer === "yes" ? "selected" : ""'
          @click='answer(curQ, "yes")'>
          はい
        </button>
        <button type='button'
          :class  ='curQ.answer === "no" ? "selected" : ""'
          @click='answer(curQ, "no")'>
          いいえ
        </button>
      </div>

      <div class="question__choices" v-if='curQ.question_type === "radio"'>
        <button v-for="(question_value, index) in curQ.question_values" :key="index" type='button'
                :class  ='curQ.answer === question_value ? "selected" : ""'
                @click='answer(curQ, question_value)'>
          {{ question_value }}
        </button>
      </div>

      <div class="survey__comment" v-if='curQ.question_type === "textarea"'>
        <label><textarea v-model='curQ.answer' rows="10"></textarea></label>
      </div>

      <div class="survey__comment" v-if='curQ.question_type === "numeric"'>
        <label><input type="number" v-model="curQ.answer" /></label>
      </div>


      <!-- <div v-if='curQ.sub_questions'></div> -->
      <div class="question__sub question" 
        v-for='(subQ, index) in curQ.sub_questions[curQ.answer]'
        :key='index'>
        <div class="question__content">{{ subQ.title }}</div>

        <div class="question__choices">
          <button type='button' :class  ='subQ.answer === "yes" ? "selected" : ""'
            @click='answer(subQ, "yes")'>
            はい
          </button>
          <button type='button' :class  ='subQ.answer === "no" ? "selected" : ""'
            @click='answer(subQ, "no")'>
            いいえ
          </button>
        </div>
      </div>
    </div>

    <div class="floating-actions" v-show='!loadFailed && questions.length > 0'>
      <button class='btn btn-danger' type='button'
        :disabled='current <= 0 || loading' 
        @click='prev'>
        前へ
      </button>
      <button class='btn' type='button'
        v-show='current < questions.length - 1' :disabled='!nextable || loading'
        @click='next'>
        次へ
      </button>
      <button class='btn' type='button'
        :disabled='!nextable || loading' v-show='current >= questions.length - 1'
        @click='submit'>
        保存
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Survey',
  props: ['order'],
  data: function() {
    return { 
      current: 0,
      comment: '',
      questions: [],

      loading: true,
      loadFailed: false,
    }
  },
  computed: {
    done: function() {
      let done = this.questions.reduce((acc, q) => {
        return q.answer ? acc + 1 : acc;
      }, 0);
      return done <= 10 ? done : 10;
    },
    curQ: function() {
      if (this.questions.length === 0) return undefined;
      return this.questions[this.current];
    },
    progress: function() {
      if (this.questions.length === 0) return "0%";
      return Math.round(this.done / this.questions.length * 100) + "%";
    },
    nextable: function() {
      if (this.loadFailed) return false;
      if (this.curQ === undefined) return false;
      if (
        this.validAnswer() &&
        this.curQ.sub_questions.yes.length === 0 &&
        this.curQ.sub_questions.no.length === 0
        ) {
        return true;
      }
      if (
        this.validAnswer() &&
        this.curQ.sub_questions[this.curQ.answer] &&
        this.curQ.sub_questions[this.curQ.answer]
          .reduce((acc, q)=> {return acc && q.answer}, true)
        ){
        return true;
      }
      return false
    }
  },
  methods: {
    next: function() {
      if (this.current <= this.questions.length - 1) 
        this.current++
    },
    prev: function() {
      if (this.current >= 1) 
        this.current--
    },
    answer: function(question, answer) {
      this.$set(question, 'answer', answer);
    },
    submit: function() {
      this.loading = true;
      this.$api
      .postOrderSurvey(this.$route.params.id, this.questions)
      .then(()=>{
        this.$$.flash();
        this.loading = false;
        this.order.order.survey_flag = 1;

        let to_path = this.order.info_steps[0].flag_campaign ? 'campaigninfo' : 'orderSteps';
        if (this.$route.params['fromPayment'] === 1) {
          delete this.$route.params['fromPayment'];
          to_path = this.order.info_steps[0].flag_campaign ? 'campaigninfo' : 'payment';
        }
        this.$router.push({
          name:   to_path,
          params: this.$route.params
        });
      })
    },
    getData: function() {
      this.loading = true;
      this.loadFailed = false;

      this.$api.getOrderSurvey(this.$route.params.id)
      .then((res) => {
        this.loading = false;

        this.loadFailed = false;
        this.questions = res.data.data;

        if (this.questions.length === 0) {
          this.$$.alert({
            message: 'アンケートデータがありません',
            actionText: '再読み込み',
            action: () => {
              this.getData();
            },
            cancelAction: () => {
              let to_path = this.order.info_steps[0].flag_campaign ? 'campaigninfo' : 'orderSteps';
              this.$router.push({name: to_path, params: this.$route.params})
            },
          })
        }
      })
      .catch((err) => {
        this.loading = false;
        if (!err.response || !err.status) {
          this.loadFailed = true;
        }
      })
    },
    validAnswer: function() {
      if (this.curQ.question_type === "textarea" && this.curQ.min_number_of_characters !== null) {
        return this.curQ.answer.length >= this.curQ.min_number_of_characters;
      } else if (this.curQ.question_type === "numeric") {
        if (this.curQ.answer.length <= 0) {
          return false;
        }
        var calcAnswer = this.curQ.answer * 1;
        var limitValue = this.curQ.question_values * 1;
        return calcAnswer <= limitValue;
      }
      return this.curQ.answer.length > 0;
    },
    validationWord: function() {
      if (this.curQ.question_type === "textarea" && this.curQ.min_number_of_characters !== null) {
        return "（" + this.curQ.min_number_of_characters + "文字以上）";
      } else if (this.curQ.question_type === "numeric" && this.curQ.question_values) {
        return "（0〜" + this.curQ.question_values + "）";
      }
      return "";
    }
  },
  created: function() {
    if (!this.order) this.$router.push({name: 'orderSteps'})
  },
  mounted: function() {
    this.$$.context({
      title: "ID:"+this.$route.params.id,
      previousRouteName: 'orderSteps',
    });
    this.getData();
  }
}
</script>
<style lang='scss'>
.survey {
  margin-bottom: 100px;
  .error {
    padding-top: 120px;
    text-align: center;
  }
  padding: 16px;
  font-size: 16px;
  p {
    font-size: 1em;
    margin-bottom: 8px;
  }
  .progress-bar {
    margin-bottom: 8px;
  }
  .floating-actions {
    .btn {
      min-width: auto;
    }
  }
  &__comment {
    textarea {
      font-size: 16px;
    }
  }
}
.question {
  font-size: 16px;
  &__content {
    font-size: 1em;
    line-height: 1.5;
    margin-top: 2em;
    margin-bottom: .5em;
    font-weight: bold;
  }
  
  &__choices {
    button {
      color: #555;
      width: 100%;
      line-height: 3;
      display: block;
      font-size: 16px;
      text-align: left;
      border-radius: 2px;
      background: #fafafa;
      white-space: nowrap;
      padding: 0 1em;
      margin-bottom: 1.5em;
      border: 1px solid #ddd;
      &:focus {
        outline: none;
      }
      &:before {
        content: '';
        display: inline-block;
        vertical-align: -.48em;
        border-radius: 50%;
        width: 24px;
        height: 24px;
        background: #fff;
        border: 1px solid #555;
        margin-right: .5em;
      }
      &.selected {
        color: #36f;
        font-weight: bold;
        &:before {
          background: #36f;
          border-color: #36f
        }
      }
    }
  }
}
</style>